import * as React from 'react';

function SvgEmailFill(props) {
  return (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.776 8.586s-2.16 1.488-4.991 3.33c-.895.496-1.714-.07-1.714-.07l-4.918-3.26c-.074 0-.149.071-.149.213v4.888c0 .567.522 1.063 1.118 1.063h9.76c.596 0 1.118-.496 1.118-1.063V8.8c-.075-.142-.149-.213-.224-.213zm-6.63 2.05c.595.355.744.284.744.284.075 0 .224 0 .745-.283 1.416-.85 4.694-2.905 5.067-3.826 0 0 .596-1.63-1.192-1.559H5.196c-1.639-.07-1.117 1.63-1.117 1.63.372.85 3.725 2.975 5.066 3.755z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgEmailFill;
